<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <!---------------------------------------TITLE--------------------------------------->
      <v-col sm="5" xs="5" md="5" lg="5" cols="12" class="pb-0">
        <v-text-field
          v-model="inst.title"
          :label="$t('institutions.form.title')"
          :rules="rules.requiredLetters"
          color="red-darken-1"
          prepend-icon="mdi-domain"
          variant="outlined"
        />
      </v-col>
      <!--------------------------------------ADDRESS-------------------------------------->
      <v-col xs="7" md="7" lg="7" cols="12" class="pb-0">
        <v-text-field
          v-model="inst.address"
          :label="$t('institutions.form.address')"
          :rules="rules.requiredLetters"
          color="red-darken-1"
          prepend-icon="mdi-list-box-outline"
          variant="outlined"
        />
      </v-col>
      <!------------------------------------UPLOAD LOGO------------------------------------>
      <v-col cols="12" md="12" lg="12">
        <div class="d-flex align-center flex-wrap ga-4">
          <div class="d-flex ">
            <div class="d-flex align-center mb-1">
              <v-icon class="mr-2" color="grey-darken-1">mdi-image-outline</v-icon>
              <label class="pr-2">
                {{ $t("institutions.form.upload_logo") }}
              </label>
              <v-tooltip location="bottom">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small" class="cursor-pointer">
                    mdi-information
                  </v-icon>
                </template>
                <span>72 x 72 {{ $t("institutions.form.preferred") }}</span>
              </v-tooltip>
            </div>
               <div class="logo-container">
            <img
              v-if="logo"
              :src="tmpLogo"
              class="institution-logo-preview"
              alt="Company Logo"
            />
            <img
              v-else-if="inst && inst.logo"
              :src="`https://leko-tech.fra1.cdn.digitaloceanspaces.com/${inst.logo}`"
              class="institution-logo-preview"
              alt="Company Logo"
            />
          </div>
            <input
              ref="logoInput"
              class="ml-8"
              accept="image/*"
              type="file"
              @change="onInput"
            />
          </div>
       
        </div>
      </v-col>

      <!---------------------------------------STATE--------------------------------------->
      <v-col xs="4" md="4" lg="4" cols="6" class="py-0">
        <v-select
          v-model="state"
          :items="states"
          :label="$t('institutions.form.state')"
          :loading="loadingState"
          :rules="rules.required"
          color="red-darken-1"
          item-title="name"
          item-value="name"
          prepend-icon="mdi-earth"
          return-object
          variant="outlined"
        />
      </v-col>
      <!---------------------------------------CITY---------------------------------------->
      <v-col xs="4" md="4" lg="4" cols="6" class="py-0">
        <v-select
          v-model="inst.city"
          :items="cities"
          :label="$t('institutions.form.city')"
          :loading="loadingCity"
          :rules="rules.required"
          color="red-darken-1"
          item-title="name"
          item-value="name"
          prepend-icon="mdi-city"
          variant="outlined"
        />
      </v-col>
        <!-------------------------------------LEKOSHOP-------------------------------------->
      <v-col xs="4" md="4" lg="4" cols="12" class="py-0">
        <v-text-field
          v-model="inst.shop"
          :label="$t('institutions.table.shop')"
          color="red-darken-1"
          prepend-icon="mdi-store"
          variant="outlined"
        />
      </v-col>
      <!---------------------------------------PHONE--------------------------------------->
      <v-col xs="4" md="4" lg="4" cols="12" class="py-0">
        <v-text-field
          v-model="inst.phone"
          :label="$t('institutions.form.phone')"
          :rules="rules.requiredNumbers"
          color="red-darken-1"
          prepend-icon="mdi-phone"
          type="number"
          variant="outlined"
        />
      </v-col>
      <!--------------------------------------WEBSITE-------------------------------------->
      <v-col xs="4" md="4" lg="4x" cols="12" class="py-0">
        <v-text-field
          v-model="inst.website"
          :label="$t('institutions.form.website')"
          :rules="rules.requiredLetters"
          color="red-darken-1"
          prepend-icon="mdi-web"
          variant="outlined"
        />
      </v-col>
    
      <!---------------------------------------Email--------------------------------------->
      <v-col xs="4" md="4" lg="4" cols="12" class="py-0">
        <v-text-field
          v-model="inst.email"
          :label="$t('institutions.form.email')"
          :rules="rules.email"
          color="red-darken-1"
          prepend-icon="mdi-email"
          variant="outlined"
        />
      </v-col>
      <!--------------------------------------RR Email------------------------------------->
      <v-col xs="5" md="5" lg="5" cols="12" class="py-0">
        <v-text-field
          v-model="inst.rrEmail"
          :label="$t('institutions.form.rr_email')"
          :rules="rules.optionalEmail"
          color="red-darken-1"
          prepend-icon="mdi-email-outline"
          variant="outlined"
        />
      </v-col>
      <!---------------------------FISCAL INFORMATION--------------------------------------->
      <v-col cols="12" class="py-0">
        <div class="text-subtitle-1 font-weight-bold mb-2">
          {{ $t("institutions.form.fiscal_information") }}
        </div>
      </v-col>
      <v-col xs="5" md="5" lg="5" cols="12" class="py-0">
        <v-text-field
          v-model="inst.fiscalInformation.companyName"
          :label="$t('institutions.form.company_name')"
          color="red-darken-1"
          prepend-icon="mdi-domain"
          variant="outlined"
        />
      </v-col>
      <v-col xs="7" md="7" lg="7" cols="12" class="py-0">
        <v-text-field
          v-model="inst.fiscalInformation.legalAddress"
          :label="$t('institutions.form.legal_address')"
          color="red-darken-1"
          prepend-icon="mdi-map-marker-outline"
          variant="outlined"
        />
      </v-col>
      <v-col xs="3" md="3" lg="3" cols="12" class="py-0">
        <v-text-field
          v-model="inst.fiscalInformation.vatNumber"
          :label="$t('institutions.form.vat_number')"
          color="red-darken-1"
          prepend-icon="mdi-identifier"
          variant="outlined"
        />
      </v-col>
      <v-col xs="3" md="3" lg="3" cols="12" class="py-0">
        <v-text-field
          v-model="inst.fiscalInformation.taxCode"
          :label="$t('institutions.form.tax_code')"
          color="red-darken-1"
          prepend-icon="mdi-card-account-details-outline"
          variant="outlined"
        />
      </v-col>
      <v-col xs="3" md="3" lg="3" cols="12" class="py-0">
        <v-text-field
          v-model="inst.fiscalInformation.legalRepresentative"
          :label="$t('institutions.form.legal_representative')"
          color="red-darken-1"
          prepend-icon="mdi-account-tie"
          variant="outlined"
        />
      </v-col>
      <v-col xs="3" md="3" lg="3" cols="12" class="py-0">
        <v-text-field
          v-model="inst.fiscalInformation.uniqueCode"
          :label="$t('institutions.form.unique_code')"
          color="red-darken-1"
          prepend-icon="mdi-barcode"
          variant="outlined"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import getRequest from "../../api/getRequest";

import { dataURLtoBlob } from "../../utils/files";

const emptyFiscalInformation = () => ({
  companyName: null,
  legalAddress: null,
  vatNumber: null,
  taxCode: null,
  legalRepresentative: null,
  uniqueCode: null,
});

export default {
  name: "GeneralSettings",
  props: ["institution"], // eslint-disable-line vue/require-prop-types
  data() {
    return {
      shop: false,
      website: false,
      valid: false,
      edit: null,
      logo: null,
      tmpLogo: "",
      dialog: false,
      loading: false,
      loadingState: false,
      loadingCity: false,
      rules: {
        requiredLetters: [
          (v) => !!v || "Please fill this field",
          (v) => /[A-Za-z]/.test(v) || "Only letters are allowed",
        ],
        requiredNumbers: [
          (v) => !!v || "Please fill this field",
          (v) => /[0-9]/.test(v) || "Only numbers are allowed",
        ],
        email: [
          (v) => !!v || "Please fill this field",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
        optionalEmail: [
          (v) => !v || /.+@.+/.test(v) || "E-mail must be valid",
        ],
      },
      states: [],
      state: {},
      cities: [],
      inst: this.institution,
    };
  },
  watch: {
    state(value) {
      if (value) {
        this.inst.state = value.name;
        this.getCities(value._id);
      }
    },
    institution: {
      immediate: true,
      handler(value) {
        if (!value) return;
        this.inst = value;
        this.logo = null;
        this.tmpLogo = "";
        this.ensureFiscalInformation();
      },
    },
  },
  beforeMount() {
    this.ensureFiscalInformation();
    this.getStates();
  },
  methods: {
    ensureFiscalInformation() {
      if (!this.inst) return;
      if (!this.inst.fiscalInformation) {
        this.inst.fiscalInformation = emptyFiscalInformation();
      } else if (this.inst.fiscalInformation.uniqueCode === undefined) {
        this.inst.fiscalInformation.uniqueCode = null;
      }
    },
    onInput(input) {
      const { files } = input.target;
      if (files && files.length > 0) {
        const { type } = files[0];
        const extension = type.split("/")[1];
        const fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        fileReader.addEventListener("load", () => {
          const dataUrl = fileReader.result;
          this.tmpLogo = dataUrl;
          this.logo = { blob: dataURLtoBlob(dataUrl), extension };
        });
      }
    },
    getStates() {
      this.loadingState = true;
      getRequest("/state")
        .then((response) => {
          this.states = response.states;
          this.loadingState = false;
          if (this.institution.state) {
            // select institution's state
            this.states.forEach((state) => {
              if (state.name === this.institution.state) this.state = state;
            });
          }
        })
        .catch(() => {
          this.loadingState = false;
        });
    },
    getCities(id) {
      this.loadingCity = true;
      getRequest("/city", `state_id=${id}`)
        .then((response) => {
          this.cities = response.cities;
          this.loadingCity = false;
        })
        .catch(() => {
          this.loadingCity = false;
        });
    },
  },
};
</script>
<style scoped>
.institution-logo-preview {
  max-width: 92px;
  max-height: 92px;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}
</style>
